/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface V1ContainerResizePolicy
 */
export interface V1ContainerResizePolicy {
    /**
     * 
     * @type {string}
     * @memberof V1ContainerResizePolicy
     */
    resourceName?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ContainerResizePolicy
     */
    restartPolicy?: string;
}

export function V1ContainerResizePolicyFromJSON(json: any): V1ContainerResizePolicy {
    return V1ContainerResizePolicyFromJSONTyped(json, false);
}

export function V1ContainerResizePolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1ContainerResizePolicy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resourceName': !exists(json, 'resourceName') ? undefined : json['resourceName'],
        'restartPolicy': !exists(json, 'restartPolicy') ? undefined : json['restartPolicy'],
    };
}

export function V1ContainerResizePolicyToJSON(value?: V1ContainerResizePolicy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resourceName': value.resourceName,
        'restartPolicy': value.restartPolicy,
    };
}

